import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { useTranslation } from "react-i18next";

const ConstructionObjectDetailMain = () => {
  const {t} = useTranslation();
  return (
    <>
    <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("Id")} fieldName={"id"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFDateInput title={t("CreatedDate")} fieldName={"createdDate"} required={true} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      
    </>
  );
};

export default ConstructionObjectDetailMain;
